import { render } from "./Phone.vue?vue&type=template&id=1f1b55f4"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__